import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import type { SortingOptionType } from 'src/pages/plan-page/types';
import { SORTING_DIRECTION } from 'src/pages/plan-page/types';
import SortDownIcon from 'src/shared/assets/icons/sort-down.svg';
import SortUpIcon from 'src/shared/assets/icons/sort-up.svg';
import { Button } from 'src/shared/components/button';

import styles from './complex-tooltip.module.scss';

interface Props {
  fieldId: string;
  sorting: SortingOptionType | null;
  onSortInAscendingOrder(): void;
  onSortInDescendingOrder(): void;
  onResetSorting(): void;
}

export const ComplexTooltip = observer(function ComplexTooltip({
  fieldId,
  onSortInAscendingOrder,
  onSortInDescendingOrder,
  onResetSorting,
  sorting,
  children,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.topButtonsContainer}>
        <button
          onClick={onSortInDescendingOrder}
          className={clsx(
            styles.iconButton,
            sorting?.direction === SORTING_DIRECTION.desc && sorting?.fieldId === fieldId && styles.iconButtonActive,
          )}
        >
          <SortDownIcon className={styles.icon} />
        </button>

        <button
          className={clsx(
            styles.iconButton,
            sorting?.direction === SORTING_DIRECTION.asc && sorting?.fieldId === fieldId && styles.iconButtonActive,
          )}
          onClick={onSortInAscendingOrder}
        >
          <SortUpIcon className={styles.icon} />
        </button>

        {sorting?.fieldId === fieldId && (
          <Button variant="text" onClick={onResetSorting} className={styles.resetButton} disabled={!onResetSorting}>
            {t('common:Buttons.resetSorting')}
          </Button>
        )}
      </div>

      {children}
    </>
  );
});
